// extracted by css-extract-rspack-plugin
export default {"cls1":"HashtagSelector-cls1_2kc","cls2":"HashtagSelector-cls2__Su HashtagSelector-cls1_2kc"};